import type { SubsSection, SubRowVariant } from '@/msgdeskRuntime/state'

type MenuMode = 'drafts' | 'trash' | 'favs'

export function mainTemplateVariant(_section: SubsSection): SubRowVariant {
  return 'auto'
}

export function menuTemplateVariant(_mode: MenuMode, _section: SubsSection): SubRowVariant {
  // Folder pages share the neutral 'folder' row (deskUi/rowTemplates/FolderRow).
  return 'folder'
}

export function nestedTemplateVariant(): SubRowVariant {
  return 'auto'
}
